/* eslint-disable */

// This file is generated by @tanstack/router-plugin at dev/build time.
// Regenerate by running `pnpm dev` once with the router plugin configured,
// or keep this hand-maintained stub in sync with src/routes/*.tsx.

import { Route as rootRoute } from "./routes/__root";
import { Route as IndexRoute } from "./routes/index";
import { Route as WorldRoute } from "./routes/world";
import { Route as HypothesesRoute } from "./routes/hypotheses";
import { Route as PortfolioRoute } from "./routes/portfolio";
import { Route as LabRoute } from "./routes/lab";
import { Route as LoginRoute } from "./routes/login";
import { Route as ForceChangePasswordRoute } from "./routes/force-change-password";
import { Route as SettingsRoute } from "./routes/settings";
import { Route as AdminUsersRoute } from "./routes/admin.users";
import { Route as AdminUsersNewRoute } from "./routes/admin.users.new";
import { Route as AdminUsersDetailRoute } from "./routes/admin.users.$id";
import { Route as AdminSettingsRoute } from "./routes/admin.settings";
import { Route as AdminAgentsRoute } from "./routes/admin.agents";
import { Route as AdminAgentInstanceRoute } from "./routes/admin.agents.$instanceId";
import { Route as AdminPlaybooksRoute } from "./routes/admin.playbooks";
import { Route as AdminPlaybookDetailRoute } from "./routes/admin.playbooks.$id";
import { Route as AdminStrategiesRoute } from "./routes/admin.strategies";

// Register all known paths so createFileRoute() type-checks correctly.
declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRoute;
      parentRoute: typeof rootRoute;
    };
    "/world": {
      id: "/world";
      path: "/world";
      fullPath: "/world";
      preLoaderRoute: typeof WorldRoute;
      parentRoute: typeof rootRoute;
    };
    "/hypotheses": {
      id: "/hypotheses";
      path: "/hypotheses";
      fullPath: "/hypotheses";
      preLoaderRoute: typeof HypothesesRoute;
      parentRoute: typeof rootRoute;
    };
    "/portfolio": {
      id: "/portfolio";
      path: "/portfolio";
      fullPath: "/portfolio";
      preLoaderRoute: typeof PortfolioRoute;
      parentRoute: typeof rootRoute;
    };
    "/lab": {
      id: "/lab";
      path: "/lab";
      fullPath: "/lab";
      preLoaderRoute: typeof LabRoute;
      parentRoute: typeof rootRoute;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRoute;
      parentRoute: typeof rootRoute;
    };
    "/force-change-password": {
      id: "/force-change-password";
      path: "/force-change-password";
      fullPath: "/force-change-password";
      preLoaderRoute: typeof ForceChangePasswordRoute;
      parentRoute: typeof rootRoute;
    };
    "/settings": {
      id: "/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof SettingsRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/users": {
      id: "/admin/users";
      path: "/admin/users";
      fullPath: "/admin/users";
      preLoaderRoute: typeof AdminUsersRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/users/new": {
      id: "/admin/users/new";
      path: "/admin/users/new";
      fullPath: "/admin/users/new";
      preLoaderRoute: typeof AdminUsersNewRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/users/$id": {
      id: "/admin/users/$id";
      path: "/admin/users/$id";
      fullPath: "/admin/users/$id";
      preLoaderRoute: typeof AdminUsersDetailRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/settings": {
      id: "/admin/settings";
      path: "/admin/settings";
      fullPath: "/admin/settings";
      preLoaderRoute: typeof AdminSettingsRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/agents": {
      id: "/admin/agents";
      path: "/admin/agents";
      fullPath: "/admin/agents";
      preLoaderRoute: typeof AdminAgentsRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/agents/$instanceId": {
      id: "/admin/agents/$instanceId";
      path: "/admin/agents/$instanceId";
      fullPath: "/admin/agents/$instanceId";
      preLoaderRoute: typeof AdminAgentInstanceRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/playbooks": {
      id: "/admin/playbooks";
      path: "/admin/playbooks";
      fullPath: "/admin/playbooks";
      preLoaderRoute: typeof AdminPlaybooksRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/playbooks/$id": {
      id: "/admin/playbooks/$id";
      path: "/admin/playbooks/$id";
      fullPath: "/admin/playbooks/$id";
      preLoaderRoute: typeof AdminPlaybookDetailRoute;
      parentRoute: typeof rootRoute;
    };
    "/admin/strategies": {
      id: "/admin/strategies";
      path: "/admin/strategies";
      fullPath: "/admin/strategies";
      preLoaderRoute: typeof AdminStrategiesRoute;
      parentRoute: typeof rootRoute;
    };
  }
}

const IndexRouteWithParent = IndexRoute.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any);

const WorldRouteWithParent = WorldRoute.update({
  id: "/world",
  path: "/world",
  getParentRoute: () => rootRoute,
} as any);

const HypothesesRouteWithParent = HypothesesRoute.update({
  id: "/hypotheses",
  path: "/hypotheses",
  getParentRoute: () => rootRoute,
} as any);

const PortfolioRouteWithParent = PortfolioRoute.update({
  id: "/portfolio",
  path: "/portfolio",
  getParentRoute: () => rootRoute,
} as any);

const LabRouteWithParent = LabRoute.update({
  id: "/lab",
  path: "/lab",
  getParentRoute: () => rootRoute,
} as any);

const LoginRouteWithParent = LoginRoute.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRoute,
} as any);

const ForceChangePasswordRouteWithParent = ForceChangePasswordRoute.update({
  id: "/force-change-password",
  path: "/force-change-password",
  getParentRoute: () => rootRoute,
} as any);

const SettingsRouteWithParent = SettingsRoute.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRoute,
} as any);

const AdminUsersRouteWithParent = AdminUsersRoute.update({
  id: "/admin/users",
  path: "/admin/users",
  getParentRoute: () => rootRoute,
} as any);

const AdminUsersNewRouteWithParent = AdminUsersNewRoute.update({
  id: "/admin/users/new",
  path: "/admin/users/new",
  getParentRoute: () => rootRoute,
} as any);

const AdminUsersDetailRouteWithParent = AdminUsersDetailRoute.update({
  id: "/admin/users/$id",
  path: "/admin/users/$id",
  getParentRoute: () => rootRoute,
} as any);

const AdminSettingsRouteWithParent = AdminSettingsRoute.update({
  id: "/admin/settings",
  path: "/admin/settings",
  getParentRoute: () => rootRoute,
} as any);

const AdminAgentsRouteWithParent = AdminAgentsRoute.update({
  id: "/admin/agents",
  path: "/admin/agents",
  getParentRoute: () => rootRoute,
} as any);

const AdminAgentInstanceRouteWithParent = AdminAgentInstanceRoute.update({
  id: "/admin/agents/$instanceId",
  path: "/admin/agents/$instanceId",
  getParentRoute: () => rootRoute,
} as any);

const AdminPlaybooksRouteWithParent = AdminPlaybooksRoute.update({
  id: "/admin/playbooks",
  path: "/admin/playbooks",
  getParentRoute: () => rootRoute,
} as any);

const AdminPlaybookDetailRouteWithParent = AdminPlaybookDetailRoute.update({
  id: "/admin/playbooks/$id",
  path: "/admin/playbooks/$id",
  getParentRoute: () => rootRoute,
} as any);

const AdminStrategiesRouteWithParent = AdminStrategiesRoute.update({
  id: "/admin/strategies",
  path: "/admin/strategies",
  getParentRoute: () => rootRoute,
} as any);

export const routeTree = rootRoute.addChildren([
  IndexRouteWithParent,
  WorldRouteWithParent,
  HypothesesRouteWithParent,
  PortfolioRouteWithParent,
  LabRouteWithParent,
  LoginRouteWithParent,
  ForceChangePasswordRouteWithParent,
  SettingsRouteWithParent,
  AdminUsersRouteWithParent,
  AdminUsersNewRouteWithParent,
  AdminUsersDetailRouteWithParent,
  AdminSettingsRouteWithParent,
  AdminAgentsRouteWithParent,
  AdminAgentInstanceRouteWithParent,
  AdminPlaybooksRouteWithParent,
  AdminPlaybookDetailRouteWithParent,
  AdminStrategiesRouteWithParent,
]);
